/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useEffect, useState } from 'react';
import { CardContent, CardHeader, Container, Expandable } from './styles'
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import BetaImg from './beta.png';
import { Label } from "components/Form";
import Colors from "constants/Colors";
import Checkbox from 'components/Form/CheckBox';

const propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.object,
};


export default function FormContainer({ title, children, maxHeight, minHeight, hide, isBeta, collapsedAtStart, isChecked, onCheckChange, hasCheckbox }) {
  const [expanded, setExpanded] = useState(true);
  const [expanding, setExpanding] = useState(false);
  const [collapsing, setCollapsing] = useState(false);
  const [beforeCollapsing, setBeforeCollapsing] = useState(false);

  const accordionState = (state) => {
    setExpanding(false);
    setCollapsing(false);
    setBeforeCollapsing(false);
    setExpanded(state);
  };

  const accordionAnimation = (state) => {
    setExpanded(false);
    if (state && !expanded) {
      setExpanding(true);
      setTimeout(() => accordionState(true), 100);
    } else if (!state && expanded) {
      setBeforeCollapsing(true);
      setTimeout(() => {
        setCollapsing(true);
        setTimeout(() => accordionState(false), 100)
      }, 10);
    }
  };

  useEffect(() => {
    if (collapsedAtStart) accordionState(false)
  }, []);

  if (hide) return <></>;

  return (
    <Container>
      <CardHeader onClick={(e) => {e.stopPropagation(); accordionAnimation(!expanded)}}>
        <div style={{display: 'flex'}}>
          {hasCheckbox &&
           <Label textColor={Colors.GRAY[0]}>
            <div style={{display: 'flex', alignItems: 'center'}} onClick={(e) => e.stopPropagation()}>
              <Checkbox
                checked={isChecked}
                onClick={(e) => {
                  onCheckChange();
                  e.stopPropagation();
                }}
              />
            </div>
          </Label>}
          {title}
          {isBeta && <img src={BetaImg} width={50} style={{ marginLeft: 10 }} />}
        </div>
        <Icon className={(!expanded || collapsing) && !expanding ? 'closed' : ''} name="arrowup-white" />
      </CardHeader>
      <CardContent className={expanded ? 'expanded' : beforeCollapsing ? 'before-collapsing' : (collapsing ? 'collapsing' : (expanding ? 'expanding' : ''))} maxHeight={maxHeight} minHeight={minHeight}>
        <Expandable>
          {children}
        </Expandable>
      </CardContent>
    </Container>
  );
}

FormContainer.propTypes = propTypes;